<script setup lang="ts">
const inputKey = ref<string>('')

const dialogStore = useDialogStore()
const dialog = dialogStore.key

const isGiftMode = computed(() => dialog.keyMode === 'gift')
const dialogTitle = computed(() => isGiftMode.value ? 'ギフトキーを入力する' : 'キーを入力する')

const emit = defineEmits<{
  (e: 'submit', key: string): void
  (e: 'cancel'): void
}>()

const onKeyInput = () => {
  // 英数字のみ抽出→大文字化→8文字上限→4文字ずつハイフンで結合（XXXX-XXXX 形式）
  const raw = inputKey.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 8)
  inputKey.value = raw.match(/.{1,4}/g)?.join('-') ?? raw
}

const onSubmit = (): void => {
  const key = inputKey.value
  inputKey.value = ''
  dialogStore.closeDialog('key', 'submit')
  emit('submit', key)
}

const onCancel = () => {
  inputKey.value = ''
  dialogStore.closeDialog('key', 'cancel')
  emit('cancel')
}
</script>

<template>
  <Dialog
    v-if="dialog.params && dialog.visible"
    :title="dialogTitle"
    :model-value="dialog.visible"
    :cancel-button="{ title: dialog.params?.actions?.cancel?.label || 'とじる' }"
    :submit-button="{ title: dialog.params?.actions?.submit?.label || '決定' }"
    @submit="onSubmit"
    @cancel="onCancel"
  >
    <template #default>
      <v-container class="align-center w-90">
        <v-row>
          <v-col
            cols="1"
            class="text-center"
          />
          <v-col
            cols="10"
            class="text-center"
          >
            <v-text-field
              v-model="inputKey"
              label=""
              class="key-edit"
              @input="onKeyInput"
            />
          </v-col>
          <v-col
            cols="1"
            class="text-center"
          />
        </v-row>
      </v-container>
    </template>
  </Dialog>
</template>

<style scoped>
.areakey {
  background-color: rgba(255, 255, 255, 0.4);
  margin: 24px auto;
}

.button-text {
  font-size: 1.3rem;
  font-weight: bold;

  margin: 16px 0;
}

.key-edit :deep(input) {
  font-family: "Google Sans Code", sans-serif;
  font-size: 5rem;
  font-weight: 700;
  text-align: center;
}

/* #721: モバイルは 5rem だと XXXX-XXXX が画面幅を超えて入力できない。
   狭幅では収まるサイズに落とす（親 Dialog は全画面化済み）。 */
@media (max-width: 768px) {
  .key-edit :deep(input) {
    font-size: 2rem;
  }
}
</style>
